module.exports = __webpack_public_path__ + "static/media/banner_desktop.8d8c9a75.png";